module.exports = __webpack_public_path__ + "images/template-empty-content.png";